import { lookupCurrency } from './currencies.js';
import { OPERATING_COUNTRY_CODES, } from '@owner/country';
import { getCurrencyForCountry, } from './countryCurrencyMappings.js';
/**
 * The {@link CurrencyCode}s used by countries in which Owner operates. For the
 * complete list of ISO-standard currency codes, see {@link CURRENCY_CODES}.
 */
export const OPERATING_CURRENCY_CODES = OPERATING_COUNTRY_CODES.map((x) => getCurrencyForCountry(x));
/**
 * All {@link OperatingCurrency}s, i.e., all currencies for countries in which
 * Owner operates.
 */
export const OPERATING_CURRENCIES = OPERATING_CURRENCY_CODES.map((x) => lookupCurrency(x));
/**
 * Narrows an arbitrary string to an {@link OperatingCurrencyCode}.
 *
 * @param value the string to check
 * @return true iff the supplied string is a valid `OperatingCurrencyCode`
 */
export const isOperatingCurrencyCode = (value) => value ? OPERATING_CURRENCY_CODES.some((x) => x === value) : false;
//# sourceMappingURL=operatingCurrencies.js.map